module.exports = __webpack_public_path__ + "img/football_bg.d297359c.png";